var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreOptionsDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9814 2C15.3851 2 15.7183 2.29312 15.7671 2.67198L15.7733 2.76836V3.44633H17.2174C18.478 3.44633 19.5 4.43788 19.5 5.66102V8.55367V11.9435H17.9161V9.32203H6.08385V15.7853C6.08385 16.1597 6.3967 16.4633 6.78261 16.4633H9.15839V18H6.78261C5.52196 18 4.5 17.0084 4.5 15.7853V8.55367V5.66102C4.5 4.43788 5.52196 3.44633 6.78261 3.44633H8.22671V2.76836C8.22671 2.34401 8.58127 2 9.01863 2C9.42236 2 9.75552 2.29312 9.80439 2.67198L9.81056 2.76836V3.44633H14.1894V2.76836C14.1894 2.34401 14.544 2 14.9814 2ZM17.9161 5.66102V7.78531H6.08385V5.66102C6.08385 5.28659 6.3967 4.98305 6.78261 4.98305H8.22671V5.66102L8.23288 5.7574C8.28175 6.13626 8.61491 6.42938 9.01863 6.42938C9.456 6.42938 9.81056 6.08537 9.81056 5.66102V4.98305H14.1894V5.66102L14.1956 5.7574C14.2445 6.13626 14.5776 6.42938 14.9814 6.42938C15.4187 6.42938 15.7733 6.08537 15.7733 5.66102V4.98305H17.2174C17.6033 4.98305 17.9161 5.28659 17.9161 5.66102Z",
    fill: "#77928B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3514 13.9257L13.4257 11L10.5 13.9257L11.524 14.9497L12.6943 13.7794V18.3143H14.1571V13.7794L15.3274 14.9497L16.3514 13.9257Z",
    fill: "#77928B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6366 19.6744L17.7109 22.6001L14.7852 19.6744L15.8092 18.6504L16.9794 19.8207V15.2858H18.4423V19.8207L19.6126 18.6504L20.6366 19.6744Z",
    fill: "#77928B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOptionsDot);
export default __webpack_public_path__ + "static/media/more-options-dot.810907046eda01bcb5f23d988a281549.svg";
export { ForwardRef as ReactComponent };